import React from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
  loading?: 'lazy' | 'eager';
  decoding?: 'async' | 'sync' | 'auto';
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  className,
  style,
  width,
  height,
  loading = 'lazy',
  decoding = 'async',
  ...props
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ display: 'block', maxWidth: '100%', objectFit: 'cover', ...style }}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
      {...props}
    />
  );
};

export default Image;
